<app-loading *ngIf="loading"></app-loading>

<ng-container *ngIf="totalRecords > 0 && !loading">
    <table class="ts-table">
        <thead>
            <tr>
                <th class="text-right-numeric header-vertical-border">Account Id</th>
                <th class="header-vertical-border">Type</th>
                <th class="header-vertical-border">Status</th>
                <th class="text-right-numeric header-vertical-border">Beginning Day Net Worth</th>
                <th class="text-right-numeric header-vertical-border">Beginning Day Buying Power</th>
                <th class="text-right-numeric header-vertical-border">Current Net Worth</th>
                <th class="text-right-numeric header-vertical-border">Current Buying Power *</th>
                <th class="header-vertical-border">User Name</th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let account of pagedAccounts$ | async">
                <tr class="element-row" [class.expanded-row]="account?.expanded" (click)="toggleRow(account)">
                    <td class="text-right-numeric">
                        <fa-icon *ngIf="!account?.expanded" [icon]="faPlus"></fa-icon>
                        <fa-icon *ngIf="account?.expanded" [icon]="faMinus"></fa-icon>
                        &nbsp;{{ account.accountId }}
                    </td>
                    <td>{{ account.type }}</td>
                    <td>{{ account.status }}</td>
                    <td class="text-right-numeric">{{ account.bodEquity | currency:'USD':'symbol':'1.2-2' }}</td>
                    <td class="text-right-numeric">{{ account.bodBuyPower | currency:'USD':'symbol':'1.2-2' }}</td>
                    <td class="text-right-numeric">{{ account.curEquity | currency:'USD':'symbol':'1.2-2' }}</td>
                    <td class="text-right-numeric">{{ account.curBuyPower | currency:'USD':'symbol':'1.2-2' }}</td>
                    <td>{{ account.userNamed }}</td>
                </tr>
                <tr class="detail-row" *ngIf="account?.expanded">
                    <td [attr.colspan]="displayedColumns.length">
                        <div class="element-detail">
                            <app-loading *ngIf="account?.loadingExpanded" sectionLoading></app-loading>
                            <table class="ts-table inner-table"
                                *ngIf="account?.positions?.length > 0 && !account?.loadingExpanded">
                                <thead>
                                    <tr>
                                        <th class="header-vertical-border">Symbol</th>
                                        <th class="text-right-numeric header-vertical-border">Quantity</th>
                                        <th class="text-right-numeric header-vertical-border">Average Price</th>
                                        <th class="header-vertical-border">Long/Short</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let position of account?.positions">
                                        <td>{{ position.symbol }}</td>
                                        <td class="text-right-numeric">{{ position.quantity }}</td>
                                        <td class="text-right-numeric">{{ position.avgPrice | currency:'USD':'symbol':'1.2-2' }}</td>
                                        <td>{{ position.longShort }}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <app-empty-state *ngIf="account?.positions?.length == 0 && !account?.loadingExpanded"
                                [icon]="faChartPie"
                                [compact]="true"
                                headline="No positions"
                                hint="This account has no open positions."></app-empty-state>
                        </div>
                    </td>
                </tr>
            </ng-container>
        </tbody>
        <tfoot>
            <tr>
                <td><b>TOTAL</b></td>
                <td></td>
                <td></td>
                <td class="text-right-numeric"><b>{{ totalBeginningDayAccountNetWorth | currency:'USD':'symbol':'1.2-2' }}</b></td>
                <td class="text-right-numeric"></td>
                <td class="text-right-numeric"><b>{{ totalCurrentAccountNetWorth | currency:'USD':'symbol':'1.2-2' }}</b></td>
                <td class="text-right-numeric"></td>
                <td></td>
            </tr>
        </tfoot>
    </table>
    <app-paginator [length]="totalRecords" [pageSize]="pageSize" [pageIndex]="pageIndex" (page)="pageChangeEvent($event)"
        [pageSizeOptions]="[10, 25, 50, 100, 500]"></app-paginator>
</ng-container>
<app-empty-state *ngIf="totalRecords == 0 && !loading"
    [icon]="faUsers"
    headline="No accounts found"
    hint="Try adjusting your search criteria."></app-empty-state>
